import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-[#FFDD59] text-black z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex-shrink-0">
            <img
              src="https://customer-assets.emergentagent.com/job_persona-digital-1/artifacts/jvwwfk5v_IST%20DXB.jpg"
              alt="Persona Agency Logo"
              className="h-20 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-4">
            <Link
              to="/"
              className="px-6 py-2 bg-[#FFDD59] text-black font-semibold rounded-lg hover:bg-yellow-400 transition min-w-[160px] text-center"
            >
              Home
            </Link>

            <Link
              to="/about"
              className="px-6 py-2 bg-[#FFDD59] text-black font-semibold rounded-lg hover:bg-yellow-400 transition min-w-[160px] text-center"
            >
              About Us
            </Link>
          </div>

          <div className="lg:hidden flex items-center space-x-4">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-[#FFDD59] border-t border-yellow-600">
          <div className="px-4 pt-4 pb-4 space-y-3">
            <Link
              to="/"
              className="block w-full text-center px-4 py-3 bg-black text-[#FFDD59] rounded-lg hover:bg-gray-900 font-semibold transition"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>

            <Link
              to="/about"
              className="block w-full text-center px-4 py-3 bg-black text-[#FFDD59] rounded-lg hover:bg-gray-900 font-semibold transition"
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
